import { render, staticRenderFns } from "./BaseOverlapIcon.vue?vue&type=template&id=43aec67c&scoped=true"
import script from "./BaseOverlapIcon.vue?vue&type=script&lang=js"
export * from "./BaseOverlapIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseOverlapIcon.vue?vue&type=style&index=0&id=43aec67c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aec67c",
  null
  
)

export default component.exports